<template>
    <div>
        <modal 
        name="createTemplateModal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto">
        <div class="v-modal">
        <div class="popup-header fromDetailsPage">
            <h2 class="popup-title" v-if="callFromEdit && editItem && checkProperty(editItem,'_id')">Edit Template</h2>
            <h2 class="popup-title" v-else>Add Template</h2>
            <span @click="$modal.hide('createTemplateModal');hideMe()">
            <em class="material-icons">close</em>
            </span>
        </div>
        <form @submit.prevent data-vv-scope="newContactform" >
        <div class="form-container" @click="formerrors.msg=''">
            <div class="form_group">
                <div class="con-select w-full select-large ">
                    <label class="form_label">Type <em>*</em></label>
                    <multiselect v-model="newTemplate.categoryDetails" :options="masterTypeList"
                    :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                    :preserve-search="true" 
                    :select-label="'Type'" track-by="_id"  :label="'name'"
                    :placeholder="'Select Type'" :preselect-first="false"
                    :data-vv-as="'Type'"
                    v-validate="'required'" :searchable="true" @search-change="getMasterTypeList"
                    name="type"  
                    :taggable="false" :key="'type-type'">
                    <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                        options selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                    </template>
                    </multiselect>
                </div>
                <span class="text-danger text-sm" v-show="errors.has('newContactform.type')">{{
                    errors.first("newContactform.type") }}</span>
            </div>
            <div class="vx-row">
                <immiInput :display="true"  :wrapclass="'md:w-full'"   cid="Name" formscope="newContactform" v-model="newTemplate.name"  :fieldName="'Name'"  :required="true"  label="Name" placeHolder="Name" />
                <selectField :display="true" :wrapclass="'md:w-full'" :listContainsId="false" :fieldsArray="[]"  :required="true" :optionslist="workLocationsList" v-model="newTemplate.noOfWorkLocations"   :fieldName="'noOfWorkLocations'" cid="noOfWorkLocations" formscope="newContactform"  label="No of Work Locations" placeHolder="No of Work Locations" />

            </div>
               
               
                    
                    <div class="form_group">
                        <label class="form_label">Template Document <em>*</em></label>
                        <div class="prepare_temp">
                            <span class="cursor add-more d-inline-flex" @click="opentemplate()">+ Prepare</span>
                            <template v-if="checkProperty(newTemplate, 'prepareTemplateId')">
                                <img @click="opentemplate()" class="cursor-pointer" src="@/assets/images/documentImage.svg"/> 
                            </template>
                            <input type="hidden" v-model="newTemplate.prepareTemplateId"  data-vv-as="Documents"  v-validate="'required'" name="tdocs">
                        </div> 
                        <span class="text-danger text-sm" v-show="errors.has('newContactform.tdocs')">
                            <em>* </em>Template Document is required</span>
                    </div>


            <div class="text-danger text-sm formerrors custom_margin" v-show="formerrors.msg">
                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
        </div>
        <div class="popup-footer relative">
            <span class="loader" v-if="loadingTemplate" ><img src="@/assets/images/main/loader.gif" /></span>
            <vs-button color="dark" @click="hideMe()" class="cancel" type="filled">Cancel </vs-button>
            <vs-button color="success" :disabled="loadingTemplate" @click="createSignTemplate"  class="save" type="filled">
                <template v-if="callFromEdit && editItem && checkProperty(editItem,'_id')">Update</template>
                <template v-else> Submit</template>
            </vs-button>
        
        </div>
        </form>
        </div>
        </modal>  
        <iframePafTemplate v-if="showTemplate" :templateUrl="templateUrl"  @hideTemplate="hideTemplate"/>
    </div>
</template>
<script>
    import _ from "lodash";
    import iframePafTemplate from "@/views/globalSettings/iframePafTemplate.vue";
    import immiPhone from "@/views/forms/fields/phonenumber.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import simpleColorPicker from "@/views/forms/fields/simpleColorPicker.vue";
    import addCategory from "@/views/bulkEmailsfolder/addCategory.vue";
    import FileUpload from "@/views/FileUpload.vue";
export default {
components:{
    iframePafTemplate,
    FileUpload,
    simpleColorPicker,
    immiInput,
    selectField,
    addCategory,
    immiPhone
},
provide() {
    return {
        parentValidator: this.$validator,
    };
},
data: () => ({
    workLocationsList:['1','2','3'],
    showTemplate:false,
    templateUrl:'',
    templateId:'',
    prepareTemplate:'',
    prepareTemplateId:'',
    document:[],
    disabled_btn:false,
    masterTypeList:[],
    newTemplate:{
        name:'',
        category:'',
        categoryDetails:null,
        prepareTemplateId:'',
        noOfWorkLocations:''
    },
    loadingTemplate:false,
    formerrors:{
        msg:''
    },
}),
props:{
    message:{
        type:Object,
        default:null
    },
    callFromEdit:{
        type:Boolean,
        default:false
    },
    editItem:{
        type:Object,
        default:null
    }
},
methods:{
    createSignTemplate(){
        this.$validator.validateAll('newContactform').then(result => {
            if(result){
                let payLoad={
                    name: this.checkProperty(this.newTemplate, 'name'),
                    tplType: this.checkProperty(this.newTemplate, 'categoryDetails', '_id'),
                    prepareTemplateId:this.checkProperty(this.newTemplate, 'prepareTemplateId'),
                    noOfWorkLocations:this.checkProperty(this.newTemplate, 'noOfWorkLocations')
                };
                let path = '/pdf-sign/save-esign-template';
                if(this.callFromEdit && this.editItem && this.checkProperty(this.editItem, '_id')){
                    payLoad['templateId'] = this.templateId;
                    path = '/pdf-sign/update-esign-template';
                }
                this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
                    this.showToster({message:res.message ,isError:false});
                    this.loadingTemplate = false;
                    this.hideMe()
                }).catch((err)=>{
                    this.formerrors.msg =err;
                    this.loadingTemplate = false;
                })
            }
        })
    },
    hideTemplate(){
        this.showTemplate = false;
        window.removeEventListener("message", this.templateMessage, false);
    },
    onIframeLoad() {
        window.addEventListener("message", this.templateMessage, false);
    },
    opentemplate(){
        let payLoad = {
            type:this.checkProperty(this.newTemplate, 'categoryDetails', '_id'),
            editing:true
        };
        if(this.callFromEdit && this.checkProperty(this.editItem, 'prepareTemplateId')){
            payLoad['templateId'] =  this.checkProperty(this.editItem, 'prepareTemplateId')
        }
        this.showTemplate = false;
        let path = '/pdf-sign/get-tpl-prepare-iframe-url'
        this.$store.dispatch("commonAction", {data:payLoad, path:path}).then((res)=>{
            let resp = res;
            if(this.checkProperty(resp, 'url')){
                this.templateUrl = resp['url'];
                if(!this.callFromEdit){
                    this.prepareTemplate = resp['templateId'];
                    // this.newTemplate['prepareTemplateId'] = this.prepareTemplate
                }
                this.showTemplate = true;
                this.onIframeLoad();
            }
        }).catch((err)=>{

        })
    },
    templateMessage(event) {
        console.log(event)
        if (event.origin === window.location.origin) {
            if(!this.callFromEdit){
                this.newTemplate['prepareTemplateId'] = this.prepareTemplate
            }
            console.log("Received message from iframe:", event.data);
            // Handle the callback data
            this.hideTemplate();
        }
        
    },
    getMasterTypeList(search='') {
        let searchString = search.trim()
        let query = {};
        query["page"] = 1;
        query["perpage"] = 10000;
        query["matcher"] = {
            "searchString":searchString,
        };
        query["category"] = "sign_doc_tpl";
        this.$store.dispatch("getMasterData", query).then((response) => {
            this.masterTypeList = response.list;
            if(this.callFromEdit  && this.editItem && this.checkProperty(this.editItem,'_id')){
                this.updateEditData();
            }else{
                this.$modal.show('createTemplateModal');
            }
        }).catch(() => {
            this.masterTypeList = [];
        });
    },
    hideMe(){
        window.removeEventListener("message", this.templateMessage, false);
        this.$emit('hideMe');
        this.$modal.hide('createTemplateModal');
    },
    updateEditData(){
        if(this.editItem && this.callFromEdit){
            if(this.checkProperty(this.editItem, '_id')){
                this.templateId = this.checkProperty(this.editItem, '_id')
            }
            if(this.checkProperty(this.editItem, 'prepareTemplateId')){
                this.newTemplate['prepareTemplateId'] = this.checkProperty(this.editItem, 'prepareTemplateId')
            }
            if(this.checkProperty(this.editItem, 'tplType') && this.checkProperty(this.masterTypeList, 'length')>0){
                let findObj = _.find(this.masterTypeList, {'_id':this.editItem['tplType']});
                if(findObj){
                    this.newTemplate['categoryDetails'] = findObj;
                }
            }
            if(this.checkProperty(this.editItem, 'name')){
                this.newTemplate['name'] = this.checkProperty(this.editItem, 'name')
            }
            if(this.checkProperty(this.editItem, 'noOfWorkLocations')){
                this.newTemplate['noOfWorkLocations'] = this.checkProperty(this.editItem, 'noOfWorkLocations')
            }
            this.$modal.show('createTemplateModal');
        }
    }
},
mounted(){
    this.getMasterTypeList()
    this.loadingTemplate=false,
    this.formerrors={
        msg:''
    };
},
beforeDestroy() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener("message", this.templateMessage, false);
}
}


</script>